import { Component, type ReactElement } from "react";
import { type Layout } from "react-grid-layout";

import { TriggerButton } from "widgets";

import { type ILicensable } from "../../redux/modules/config.js";
import { type DashboardCardType, type TSpecificDashboardCardConfig } from "../../redux/modules/dashboard.js";
import { CardIcons } from "../../settings/assets-settings.js";

export interface IDashboardCardPanelProps {
  cards: IGenericDashboardCard[];
  onClose: () => void;
  setDroppingItem: (card: IGenericDashboardCard) => void;
}

export interface IGenericDashboardCard extends ILicensable {
  type: DashboardCardType;
  name: string;
  description: string;
  defaultLayout: Partial<Layout>;
  overview?: any; // TBD
  specificConfig?: TSpecificDashboardCardConfig;
  icon: CardIcons;
}

class AddDashboardCardPanel extends Component<IDashboardCardPanelProps> {
  constructor(props: IDashboardCardPanelProps) {
    super(props);
  }

  onDragStart = (e, card: IGenericDashboardCard) => {
    // this is a hack for firefox
    // Firefox requires some kind of initialization
    // which we can do by adding this attribute
    // @see https://bugzilla.mozilla.org/show_bug.cgi?id=568313
    e.dataTransfer.setData("text/plain", "");
    this.props.setDroppingItem(card);
  };

  render(): ReactElement {
    return (
      <div className={`add-dashboard-card-panel`}>
        <div className={"add-dashboard-card-panel-header"}>
          <div className={"add-dashboard-card-panel-header-title"}>Add a new Card</div>
          <TriggerButton icon={"close"} label={"Close"} onPress={this.props.onClose} />
        </div>

        <div className={"add-dashboard-card-panel-body"}>
          <p className={"add-card-title"}>Type of the new card</p>
          Drag and Drop the card of your choice to the current dashboard. You can configure it later.
          {this.props.cards.map((card: IGenericDashboardCard, index) => (
            <div
              className={"add-card-box"}
              draggable={true}
              unselectable="on"
              onDragStart={(e) => this.onDragStart(e, card)}
              key={`${card.name}-${index}`}
            >
              <div className={"add-card-box-overview"}>
                <img draggable={false} width={100} height={80} src={card.icon || CardIcons.LISTING} />
              </div>
              <div className={"add-card-box-text"}>
                <div className={"add-card-box-name"}>{card.name}</div>
                <div className={"add-card-box-description"}>{card.description} </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default AddDashboardCardPanel;
